import { render, staticRenderFns } from "./NeighboorsSlider.vue?vue&type=template&id=1d1dcb72&scoped=true&"
import script from "./NeighboorsSlider.vue?vue&type=script&lang=js&"
export * from "./NeighboorsSlider.vue?vue&type=script&lang=js&"
import style0 from "./NeighboorsSlider.vue?vue&type=style&index=0&id=1d1dcb72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1dcb72",
  null
  
)

export default component.exports